import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch } from '../../store';
import { fetchOrganisations } from '../../store/slices/organizationSlice';
import { logger } from '../../utils/logger';

export const useOrganizations = () => {
  const dispatch: AppDispatch = useDispatch();
  const { items, selectedOrganisation, isLoading, error } = useSelector(
    (state: RootState) => state.organizations
  );

  useEffect(() => {
    const loadOrganizations = async () => {
      try {
        await dispatch(fetchOrganisations());
      } catch (error) {
        logger.error('Failed to load organizations:', error);
      }
    };

    loadOrganizations();
  }, [dispatch]);

  return {
    organizations: items,
    selectedOrganisation,
    isLoading,
    error,
  };
};
